import { Action } from 'redux';
import { NotificationModel } from 'models/NotificationModel';

export const NOTIFICATION_SET = 'NOTIFICATION_SET';
export const NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE';

type NotificationArgs = Omit<NotificationModel, 'show'>;
export type NotificationSetAction = Action & NotificationArgs;
export const notificationSet = (args: NotificationArgs): NotificationSetAction => ({
  type: NOTIFICATION_SET,
  ...args
});
export const notificationClose = (): Action => ({
  type: NOTIFICATION_CLOSE
});
